import React from "react";
import ScreenSelector from "@icarius-common/screenSelector";
import paths from "@icarius-router/paths";
import { getLocalizedString } from "@icarius-localization/strings";
import { PermissionsIcon, AdvancesIcon } from "@icarius-icons/";
import useIsSocietyCountry from "@icarius-app/components/wrapper/hooks/useIsSocietyCountry";

const RequestsSettings = () => {
    const isPeru = useIsSocietyCountry("PE");

    const data = [
        {
            name: getLocalizedString("permissionsSettings"),
            icon: <PermissionsIcon />,
            path: paths.permissionsSettings,
        },
        {
            name: getLocalizedString(isPeru ? "advanceOrAdvancedPaymentSettings" : "advancesSettings"),
            icon: <AdvancesIcon />,
            path: paths.advancesSettings,
        },
    ];

    return <ScreenSelector title={getLocalizedString("requestsSettings")} data={data} />;
};

export default RequestsSettings;
